<template>
  <CarouselBanner
    :ga-action="'concert_banner_click'"
    :banner-orin-data="bannerData"
    :banner-duration="bannerDuration"
  />
</template>

<script>
import CarouselBanner from '@/components/common/CarouselBanner.vue'
import CarouselService from '@/assets/services/CarouselService'

export default {
  name: 'ConcertTopBanner',
  components: {
    CarouselBanner
  },
  props: {},
  data() {
    return {
      bannerDuration: 6000,
      bannerData: []
      // bannerData: [{
      //   img: require('@/assets/images/concert/banner01.jpg'),
      //   url: 'https://muk.page.link/JQf1',
      //   label: '第10屆 臺灣國際打擊樂節(TIPC)'
      // }, {
      //   img: require('@/assets/images/concert/banner02.jpg'),
      //   url: 'https://muk.page.link/UWTF',
      //   label: 'TSO 亞洲本色'
      // }, {
      //   img: require('@/assets/images/concert/banner03.jpg'),
      //   url: 'https://muk.page.link/jjqJ',
      //   label: '2019TIFA台灣國際藝術節'
      // }]
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    bannerData(newVal) {
      this.bannerData = newVal
    }
  },
  created() {
  },
  mounted() {
    this.getBannerData()
  },
  methods: {
    async getBannerData() {
      const banners = await CarouselService.getBanners('concert')
      if (banners) {
        this.bannerData = banners.bannerData
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.mk-banner{
  margin-top: 16px;
}

@media only screen and (max-width: 1023.98px) {
}

@media only screen and (max-width: 767.98px) {
}

</style>
